import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCircle = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 1.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13z" />
    </g>
  );
};

export default withIcon(IconCircle);
